import React from "react";

import { useRemoveResourceFromResourceGroup } from "@planzone/view-models";
import { User } from "./user";
import { RemoveIcon } from "./removeIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Resource({ group, ...props }: Props) {
  const resource =
    "resource" in props ? props.resource : props.projectResource.resource;
  const { removeResourceFromResourceGroup } =
    useRemoveResourceFromResourceGroup(group, resource);

  return (
    <div
      className={styles.resource}
      onClick={() =>
        removeResourceFromResourceGroup({
          group,
          resource:
            "projectResource" in props ? props.projectResource : props.resource,
        })
      }
    >
      <User resource={resource} />
      <div className={styles.removeResourceIconContainer}>
        <RemoveIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { Resource };
